import { LocationItem } from 'components/types/LocationTypes';
import React from 'react';
import LocationsMap from '../shared/LocationsMap';
import ProviderLocation from './ProviderLocation';

type ProviderLocationsProps = {
	locations: Array<LocationItem>;
	providerId: string;
	providerName: string;
	ksb: boolean;
	deptDays: { [key: string]: string[] };
	//update this type
	userDistance?: any;
};

const ProviderLocations = (props: ProviderLocationsProps): JSX.Element => {
	const { locations, providerId, providerName, ksb, deptDays, userDistance } = props;

	let destinations = Array<Array<number>>();
	locations.forEach((_, index) => {
		destinations.push([
			parseFloat(locations[index]?.fields?.Latitude?.value),
			parseFloat(locations[index]?.fields?.Longitude?.value),
		]);
	});

	return (
		<>
			{locations && (
				<div id="locations" className="profile-section provider-locations">
					<h2>Locations</h2>
					{locations?.length > 1 ? (
						<p>
							This provider practices at multiple locations. Please choose a location before
							scheduling.
						</p>
					) : (
						''
					)}
					<div id="map-container" style={{ height: '400px' }} data-coords={destinations}>
						<LocationsMap coords={destinations} iconUrl="/images/blue-circle.svg" />
					</div>
					{locations.map((location, index) => {
						return (
							<ProviderLocation
								key={`location-${index}`}
								index={index}
								location={location}
								providerId={providerId}
								providerName={providerName}
								ksb={ksb}
								deptDays={deptDays}
								userDistance={userDistance}
							/>
						);
					})}
					<div id="provider-location-modal-root"></div>
				</div>
			)}
		</>
	);
};

export default ProviderLocations;
